module.exports = __webpack_public_path__ + "img/reject.6a688539.svg";